export default __webpack_public_path__ + "static/media/095-pitcairn-islands.08ff586f.svg";